import Colors from '@constants/Colors';
import { Avatar, AvatarGroup, Box, Button, FormLabel, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import React from 'react';

import { AssignJobOfferDialog } from './AssignJobOfferDialog';
import { getAssigneeDisplayInfo } from '../utils/assignee-utils';

type Props = {
    value: any[];
    onChange: (value: any[]) => void;
    proId?: string;
};

const AssignJobOfferButton = (props: Props) => {
    const [data, setData] = React.useState(null);
    const handleOpen = e => {
        e.stopPropagation();
        setData({});
    };

    const handleClose = () => {
        setData(null);
    };

    return (
        <>
            <FormLabel>Attribuer l'offre à un membre de l'équipe</FormLabel>
            <Stack style={{ display: 'flex' }} mt={1} alignItems={'flex-start'}>
                <AvatarGroup
                    max={5}
                    onClick={handleOpen}
                    sx={{
                        display: 'flex',
                        flexDirection: 'row-reverse',
                    }}>
                    {props.value?.map(assignee => {
                        const assigneeInfo = getAssigneeDisplayInfo(assignee);

                        return (
                            <Tooltip
                                key={assignee?._id}
                                title={`${assigneeInfo.firstName} ${assigneeInfo.lastName} (${assigneeInfo.email})`}
                                arrow
                                placement="top">
                                <Avatar
                                    key={assignee?._id}
                                    src={assigneeInfo.photo}
                                    sx={{
                                        width: 36,
                                        height: 36,
                                        fontSize: 14,
                                        bgcolor: assigneeInfo.color ?? Colors.PRIMARY,
                                    }}>
                                    {`${assigneeInfo.firstName[0] || 'U'}`.toUpperCase()}
                                </Avatar>
                            </Tooltip>
                        );
                    })}
                    <Tooltip title="Attribuer un personne" arrow placement="top">
                        <Avatar
                            component={IconButton}
                            sx={{
                                width: '36px',
                                height: '36px',
                                padding: 0,
                                bgcolor: Colors.PRIMARY,
                                '&:hover': {
                                    bgcolor: Colors.PRIMARY_PURPLE_70,
                                },
                            }}>
                            <i className="fi-br-pencil" style={{ fontSize: 16 }} />
                        </Avatar>
                    </Tooltip>
                </AvatarGroup>
            </Stack>
            <AssignJobOfferDialog
                open={!!data}
                onClose={handleClose}
                job={{
                    assignees: props.value,
                    proId: props.proId,
                }}
                onSelected={(values: any) => {
                    props.onChange(values);
                    // setData(null);
                }}
            />
        </>
    );
};

export default AssignJobOfferButton;
